import { Component, OnInit, OnDestroy } from '@angular/core'
import Validator from '@shared/validatorjs/src/validator'
import { Store, select } from '@ngrx/store'
import { LoginRequest, UpdateField, SetDefaultData } from '../auth.actions'
import FormTrait from 'src/app/traits/form.trait'
import { getLoginState } from '../auth.selectors'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'
import { FetchStaticContentTemplateRequest } from '@containers/static-content-templates/static-content-templates.actions'
import { getUpdateStaticContentTemplateState } from '@containers/static-content-templates/static-content-templates.selectors'
import { TranslateService } from '@ngx-translate/core'
import { FetchStaticTemplateRequest } from '@shared/shared.actions'
import { getStaticTemplateState } from '@shared/shared.select'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent extends FormTrait implements OnInit, OnDestroy {
  public isLoading: boolean
  private state$: Subscription
  public twoFactorVerificationCodeSent: boolean
  public validityTime: number
  public validityMs: number
  public validityTimer: any
  public codeExpired: boolean
  public passwordVisible: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('login'))
    this.state$ = this.store.pipe(select(getLoginState)).subscribe((state) => {
      this.state = state
      this.isLoading = state.get('isLoading')
      this.twoFactorVerificationCodeSent = state.get(
        'twoFactorVerificationCodeSent',
      )

      if (
        state.get('validityMs') &&
        this.validityMs !== state.get('validityMs')
      ) {
        this.validityMs = state.get('validityMs')
        this.setTimer(state.get('validityMs'))
      }
    })
  }

  setTimer(validityMs: number) {
    clearTimeout(this.validityTimer)

    this.validityTime = validityMs
    this.codeExpired = false

    this.validityTimer = setInterval(() => {
      if (this.validityTime >= 1000) {
        this.validityTime = this.validityTime - 1000
      } else {
        this.codeExpired = true
        clearTimeout(this.validityTimer)
      }
    }, 1000)
  }

  loginAgain() {
    this.store.dispatch<any>(new SetDefaultData('login'))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      email: 'required|email',
      password: 'required',
    }

    if (this.twoFactorVerificationCodeSent) {
      rules['twoFactorCode'] = 'required'
    }

    const validator = new Validator(
      {
        email: data.get('email'),
        password: data.get('password'),
        twoFactorCode: data.get('twoFactorCode'),
      },
      rules,
      {
        twoFactorCode: 'two factor code',
      },
    )

    return validator
  }

  public handleFieldChange(e: any): void {
    this.store.dispatch(
      new UpdateField(e.target.name, e.target.value, 'login.data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(e.target.name),
        'login',
      ),
    )
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (this.twoFactorVerificationCodeSent) {
      delete payload.password
    }

    if (validation.passes()) {
      this.store.dispatch(new LoginRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'login'),
      )
    }
  }
}
